import React from "react"
import "./index.scss"
import { sample } from "lodash"

const buttonClasses = ["-green", "-blue", "-salmon", "-sun", "-alge", "-flower"]

export const TagButton = ({ text }) => {
    const buttonClass = `button ${sample(buttonClasses)}`
    return <span className={buttonClass}>{text}</span>
}
